import { render } from "./AppSubmenu.vue?vue&type=template&id=02e5bf04"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"

import exportComponent from "D:\\eclipse\\workSpaceIDEA\\BioTechLeague_HUIDU_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__